import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithPopup } from 'firebase/auth';

import { auth, googleProvider } from '../Utils/firebaseConfig';

import './LoginPage.css';

import { API_BASE_URL } from '../../config';

import UserSignUpDialog from "../UserMaster/UserSignUp";

const LoginPage = ({ onClose, hideExtras = false, loginType = 'operator' }) => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  // ==========================================
  // LOGIN
  // ==========================================

  const handleLogin = async (e) => {

    e.preventDefault();

    setLoading(true);
    setError('');

    try {

      // ==========================================
      // LOGIN API
      // ==========================================

      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
       body: JSON.stringify({
  companyName: companyName.trim(),
  username: username.trim(),
  password: password.trim()
})
      });

      if (!response.ok) {

        const errorData = await response.json();

        setError(errorData.error || 'Login failed');

        setLoading(false);

        return;
      }

      const data = await response.json();

      // ==========================================
      // SAVE LOGIN DATA
      // ==========================================

      sessionStorage.setItem('token', data.jwtToken);

      sessionStorage.setItem("userRole", data.userRole);

      sessionStorage.setItem(
        "cachedPermission",
        JSON.stringify(data.roleModulePermissionDTOs)
      );

      sessionStorage.setItem(
        "ROLE_PERMISSIONS",
        JSON.stringify(data.permissions)
      );

      sessionStorage.setItem("userName", data.userName);

      sessionStorage.setItem("userId", data.userId);

      sessionStorage.setItem("companyId", data.companyId);

      sessionStorage.setItem("tenantId", data.companyId);

      // ==========================================
      // LOAD MENU ONLY ONCE AFTER LOGIN
      // ==========================================

      const menuResponse = await fetch(`${API_BASE_URL}/menu/getMenu`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${data.jwtToken}`
        },
       body: JSON.stringify({
          roleCode: data.userRole,
          tenantId: data.companyId
        })
      });

      if (menuResponse.ok) {

        const menuData = await menuResponse.json();

        // SAVE MENU IN SESSION
        sessionStorage.setItem(
          "menuItems",
          JSON.stringify(menuData)
        );
      }

      // ==========================================
      // NAVIGATION
      // ==========================================

      if (data.userRole === 'HOSTELER') {

        navigate('/hostellerDashboard');

      } else if (data.userRole === 'HOSTEL_OPERATOR') {

        navigate('/hostelOperatorDashboard');

      } else if (data.userRole === 'ADMIN') {

        navigate('/adminDashboard');

      } else if (data.userRole === 'HOTEL_MANAGER') {

        navigate('/hotelOperatorDashboard');

      } else if (data.userRole === 'SALES_MANAGER') {

        navigate('/salesDashboard');

      } 
	  else {

        navigate('/dashboard');
      }

      if (onClose) {
        onClose();
      }

    } catch (err) {

      setError(
        'An error occurred while trying to login. Please try again.'
      );

    } finally {

      setLoading(false);
    }
  };

  // ==========================================
  // GOOGLE LOGIN
  // ==========================================

  const handleGoogleSignIn = async () => {

    setLoading(true);
    setError('');

    try {

      await signInWithPopup(auth, googleProvider);

      navigate('/dashboard');

      if (onClose) {
        onClose();
      }

    } catch (error) {

      setError(
        error.message || 'Failed to log in with Google.'
      );
    }

    setLoading(false);
  };

  return (
    <div className="login-form">

      <h2>Login</h2>

      {error && (
        <p className="error">{error}</p>
      )}

      {/* LOGIN FORM */}

      <form onSubmit={handleLogin}>

        <div className="form-group">
    <label htmlFor="companyName">
        Organization
    </label>

    <input
        type="text"
        id="companyName"
        value={companyName}
        onChange={(e) => setCompanyName(e.target.value)}
        required
        autoComplete="organization"
        placeholder="Organization Name"
    />
</div>

<div className="form-group">
    <label htmlFor="username">
        Username
    </label>

    <input
        type="text"
        id="username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
        autoComplete="username"
    />
</div>

<div className="form-group">
    <label htmlFor="password">
        Password
    </label>

    <input
        type="password"
        id="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        autoComplete="current-password"
    />
</div>
        <button
          type="submit"
          disabled={loading}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>

      </form>

      {/* EXTRA OPTIONS */}

      {loginType !== 'hosteler' && !hideExtras && (
        <>

          <div className="divider">
            OR
          </div>

          {/* GOOGLE LOGIN */}

          <button
            onClick={handleGoogleSignIn}
            className="google-signin-button"
            disabled={true}
          >
            Sign in with Google
          </button>

        </>
      )}

      {/* SIGNUP POPUP */}

      <UserSignUpDialog
        open={open}
        onClose={(success) => {

          setOpen(false);

          if (success) {
            console.log("User created successfully!");
          }
        }}
      />

    </div>
  );
};

export default LoginPage;